import { generatedVisualUrl } from '../../shared/media/pipelineFiles'
import { getMediaUrl } from '../../utils/mediaUtils'
import type { PimMarketplaceCard } from './pim-drafts-api'

/**
 * Адрес плитки черновика и запасной к нему.
 *
 * Публичный адрес визуала отдаёт только оригинал в 430–490 КБ, поэтому плитку
 * просим у нашего маршрута миниатюр, а публичный держим запасным: файла в томе
 * может не оказаться, и тогда плитка честно покажет полный кадр. Тот же приём
 * у мастера склейки и каталога сайта.
 */
export function draftPreviewSources(
  card: Pick<PimMarketplaceCard, 'preview_url' | 'preview_path' | 'design_code'>,
): { src: string; fallbackSrc?: string } | null {
  if (!card.preview_url) return null
  const direct = getMediaUrl(card.preview_url, Number(card.design_code) || undefined)
  return card.preview_path
    ? { src: generatedVisualUrl(card.preview_path), fallbackSrc: direct }
    : { src: direct }
}
